module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-encurso-ac1c079b94ef3215ce9ed58970450e03.svg";